module.exports = __webpack_public_path__ + "img/zh.e6906545.png";